<p-toast position="top-center" key="tclogin"></p-toast>
<div
  *ngIf="showEmailModal"
  id="passwordModal1"
  class="modal fixed inset-0 bg-black bg-opacity-70 flex items-start justify-center z-50 overflow-y-auto"
  (click)="onHide()"
>
  <div
    class="relative card_color rounded-lg max-w-md w-full flex flex-col md:flex-row text_white overflow-hidden shadow-lg mx-4 sm:mx-8 my-10 max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón de cierre -->
    <button
      class="close-modal absolute top-4 right-4 text_gray hover:text_white text-2xl font-bold"
      (click)="onHide()"
    >
      &times;
    </button>

    <!-- Formulario de inicio de sesión -->
    <div
      class="w-full p-6 sm:p-8 flex flex-col justify-center card_color rounded-b-lg md:rounded-r-lg md:rounded-bl-none"
    >
      <div class="mb-4">
        <img
          [src]="logo ? logo : 'assets/images/no-photo-available.png'"
          alt="Logo"
          class="mx-auto"
          width="200"
          height="60"
        />
      </div>

      <h2 class="text-xl sm:text-2xl font-medium mb-2 text-left">
        Recuperación de Contraseña
      </h2>
      <p class="text-md font-light mb-2 sm:mb-3">
        Ingresa tu correo electrónico para el proceso de recuperación. En caso
        de ser válido, te enviaremos un código de 4 dígitos para su
        verificación.
      </p>

      <form class="space-y-4" [formGroup]="recoverPasswordForm">
        <div class="relative">
          <label
            for="loginEmail"
            class="block mb-2 text-sm font-medium text_gray"
            >Correo Electrónico</label
          >
          <div class="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-mail absolute left-3 text_color_customize"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z"
              />
              <path d="M3 7l9 6l9 -6" />
            </svg>
            <input
              formControlName="email"
              type="email"
              name="email"
              id="loginEmail"
              class="text_white placeholder_gray_customize sm:text-sm border-2 rounded-lg focus_line_customize focus_line_color_customize block w-full p-3 bg_color pl-10"
              placeholder="Captura tu correo electrónico"
              required
            />
          </div>
          <div
            *ngIf="
              recoverPasswordForm.controls['email'].invalid &&
              (recoverPasswordForm.controls['email'].dirty ||
                recoverPasswordForm.controls['email'].touched) &&
              recoverPasswordForm.controls['email'].value !== ''
            "
          >
            <small class="text-red-500"
              >Captura un correo electrónico válido</small
            >
          </div>
        </div>

        <button
          (click)="onSubmit()"
          [disabled]="
            recoverPasswordForm.controls['email'].invalid ||
            !recoverPasswordForm.controls['email'].value ||
            processing
          "
          [class.pointer-events-none]="
            recoverPasswordForm.controls['email'].invalid ||
            !recoverPasswordForm.controls['email'].value ||
            processing
          "
          class="open-forgot-your-password-02 w-full my-2 block py-3 font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg"
        >
          <div class="inline-flex items-center">Enviar correo electrónico</div>
        </button>
      </form>
    </div>
  </div>
</div>

<div
  *ngIf="showCodeModal"
  id="passwordModal2"
  class="modal fixed inset-0 bg-black bg-opacity-70 flex items-start justify-center z-50 overflow-y-auto"
  (click)="onHide()"
>
  <div
    class="relative card_color rounded-lg max-w-md w-full flex flex-col md:flex-row text_white overflow-hidden shadow-lg mx-4 sm:mx-8 my-10 max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón de cierre -->
    <button
      class="close-modal absolute top-4 right-4 text_gray hover:text_white text-2xl font-bold"
      (click)="onHide()"
    >
      &times;
    </button>

    <!-- Formulario de verificación -->
    <div
      class="w-full p-6 sm:p-8 flex flex-col justify-center card_color rounded-b-lg md:rounded-r-lg md:rounded-bl-none"
    >
      <div class="mb-4">
        <img
          [src]="logo ? logo : 'assets/images/no-photo-available.png'"
          alt="Logo"
          class="mx-auto"
          width="200"
          height="60"
        />
      </div>

      <h2 class="text-xl sm:text-2xl font-medium mb-2 text-left">
        Verificación
      </h2>
      <p class="text-md font-light mb-2 sm:mb-3">
        Ingresa el código de 4 dígitos que recibiste en tu correo electrónico.
      </p>

      <form class="space-y-4" [formGroup]="codeForm">
        <div class="flex justify-center gap-4">
          <!-- Campo 1 -->
          <input
            #digit1
            formControlName="digit1"
            (input)="onEnterCode(1, $event)"
            type="text"
            maxlength="1"
            class="text_white bg_color w-12 h-12 sm:w-14 sm:h-14 text-center text-lg font-medium rounded-lg focus_line_customize focus_line_color_customize"
            required
          />
          <!-- Campo 2 -->
          <input
            #digit2
            formControlName="digit2"
            (input)="onEnterCode(2, $event)"
            type="text"
            maxlength="1"
            class="text_white bg_color w-12 h-12 sm:w-14 sm:h-14 text-center text-lg font-medium rounded-lg focus_line_customize focus_line_color_customize"
            required
          />
          <!-- Campo 3 -->
          <input
            #digit3
            formControlName="digit3"
            (input)="onEnterCode(3, $event)"
            type="text"
            maxlength="1"
            class="text_white bg_color w-12 h-12 sm:w-14 sm:h-14 text-center text-lg font-medium rounded-lg focus_line_customize focus_line_color_customize"
            required
          />
          <!-- Campo 4 -->
          <input
            #digit4
            formControlName="digit4"
            (input)="onEnterCode(4, $event)"
            type="text"
            maxlength="1"
            class="text_white bg_color w-12 h-12 sm:w-14 sm:h-14 text-center text-lg font-medium rounded-lg focus_line_customize focus_line_color_customize"
            required
          />
        </div>

        <button
          type="submit"
          class="open-forgot-your-password-03 w-full my-2 block py-3 font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg"
          (click)="validateCurrentCode()"
          [disabled]="
            !codeForm.controls['digit1'].value ||
            !codeForm.controls['digit2'].value ||
            !codeForm.controls['digit3'].value ||
            !codeForm.controls['digit4'].value ||
            processing
          "
          [class.pointer-events-none]="
            !codeForm.controls['digit1'].value ||
            !codeForm.controls['digit2'].value ||
            !codeForm.controls['digit3'].value ||
            !codeForm.controls['digit4'].value ||
            processing
          "
        >
          <div class="inline-flex items-center">Continuar</div>
        </button>

        <div class="text-center mt-4 text-sm text_gray">
          Si no recibiste un código,
          <button
            class="open-register-modal text_color_customize hover:underline"
            (click)="resendEmail()"
          >
            ¡Reenviar!
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div
  *ngIf="showPasswordModal"
  id="passwordModal3"
  class="modal fixed inset-0 bg-black bg-opacity-70 flex items-start justify-center z-50 overflow-y-auto"
  (click)="onHide()"
>
  <div
    class="relative card_color rounded-lg max-w-md w-full flex flex-col md:flex-row text_white overflow-hidden shadow-lg mx-4 sm:mx-8 my-10 max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón de cierre -->
    <button
      class="close-modal absolute top-4 right-4 text_gray hover:text_white text-2xl font-bold"
      (click)="onHide()"
    >
      &times;
    </button>

    <!-- Formulario de inicio de sesión -->
    <div
      class="w-full p-6 sm:p-8 flex flex-col justify-center card_color rounded-b-lg md:rounded-r-lg md:rounded-bl-none"
    >
      <div class="mb-4">
        <img
          [src]="logo ? logo : 'assets/images/no-photo-available.png'"
          alt="Logo"
          class="mx-auto"
          width="200"
          height="60"
        />
      </div>

      <h2 class="text-xl sm:text-2xl font-medium mb-2 text-left">
        Establecer Nueva Contraseña
      </h2>
      <p class="text-md font-light mb-2 sm:mb-3">
        Establece una nueva contraseña para iniciar sesión en tu cuenta.
      </p>

      <form class="space-y-4" [formGroup]="passwordForm">
        <!-- Primer campo de "Establecer contraseña" -->
        <div class="relative w-full">
          <!-- Ícono de candado a la izquierda -->
          <div
            class="absolute inset-y-0 left-3 flex items-center pointer-events-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-lock-password"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
              />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
              <path d="M15 16h.01" />
              <path d="M12.01 16h.01" />
              <path d="M9.02 16h.01" />
            </svg>
          </div>
          <!-- Input para establecer contraseña -->
          <input
            formControlName="newPassword"
            [type]="showNewPassword ? 'text' : 'password'"
            id="password2"
            placeholder="Nueva Contraseña"
            class="w-full pl-10 pr-10 p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize"
          />
          <!-- Ícono de ojo para mostrar/ocultar contraseña a la derecha -->
          <div
            class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
            (click)="showNewPassword = !showNewPassword"
          >
            <svg
              id="eye-icon-password1"
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-eye w-5 h-5 text_color_customize"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              fill="none"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
              <path
                d="M22 12c-2.667 -4 -5.333 -6 -8 -6s-5.333 2 -8 6c2.667 4 5.333 6 8 6s5.333 -2 8 -6"
              />
            </svg>
          </div>
        </div>
        <small
          style="color: #fc6161"
          *ngIf="
            passwordForm.get('newPassword')?.dirty &&
            passwordForm.get('newPassword')?.hasError('custom')
          "
          class="p-invalid"
          >{{ passwordForm.get("newPassword")?.getError("custom") }}</small
        >

        <!-- Segundo campo de "Confirmar contraseña" -->
        <div class="relative w-full">
          <div
            class="absolute inset-y-0 left-3 flex items-center pointer-events-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="text_color_customize icon icon-tabler icons-tabler-outline icon-tabler-lock-password"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
              />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
              <path d="M15 16h.01" />
              <path d="M12.01 16h.01" />
              <path d="M9.02 16h.01" />
            </svg>
          </div>
          <input
            formControlName="confirmPassword"
            [type]="showConfirmPassword ? 'text' : 'password'"
            type="password"
            id="password3"
            placeholder="Confirmar Nueva Contraseña"
            class="w-full pl-10 pr-10 p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize"
          />
          <div
            class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
            (click)="showConfirmPassword = !showConfirmPassword"
          >
            <svg
              id="eye-icon-password2"
              xmlns="http://www.w3.org/2000/svg"
              class="icon icon-tabler icon-tabler-eye w-5 h-5 text_color_customize"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              fill="none"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
              <path
                d="M22 12c-2.667 -4 -5.333 -6 -8 -6s-5.333 2 -8 6c2.667 4 5.333 6 8 6s5.333 -2 8 -6"
              />
            </svg>
          </div>
        </div>
        <small
          style="color: #fc6161"
          *ngIf="
            passwordForm.get('confirmPassword')?.dirty &&
            passwordForm.get('confirmPassword')?.hasError('custom')
          "
          class="p-invalid"
          >{{ passwordForm.get("confirmPassword")?.getError("custom") }}</small
        >

        <button
          type="submit"
          class="open-login-modal-01 w-full my-2 block py-3 font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg"
          (click)="changePassword()"
          [disabled]="
            passwordForm.controls['newPassword'].invalid ||
            passwordForm.controls['confirmPassword'].invalid ||
            processing
          "
          [class.pointer-events-none]="
            passwordForm.controls['newPassword'].invalid ||
            passwordForm.controls['confirmPassword'].invalid ||
            processing
          "
        >
          <div class="inline-flex items-center">Confirmar</div>
        </button>
      </form>
    </div>
  </div>
</div>
